const startAutoDataApps = (
  disposing = false,
  autoData: AutoData
): DisposableApp[] => {
  const startedApps: DisposableApp[] = [];

  /**
   *
   * Autodata collapsible elements :
   *
   * C-1 : contact
   * G-2 : category
   *
   * **/
  const appDOMNodesCollapsible = dom.querySelectorAll(".autodata-collapsible");

  if (appDOMNodesCollapsible.length > 0) {
    import(
      "./collapsible" /* webpackChunkName: "app-autodata-collapsible" */
    ).then(({ default: startApp }) => {
      if (!disposing) {
        startedApps.push(startApp(appDOMNodesCollapsible, autoData));
      }
    });
  }

  /**
   *
   * Autodata on clicks :
   *
   * B-1 : search input
   * D-1 : similarQuestions
   * E-1 : thematicQuestion
   * E-2 : thematicQuestion
   * F-2 : searchResult
   * G-1 : thematicCards
   * G-3 : toggleThematic
   * H-1 : breadcrumb (thematic)
   * H-2 : breadcrumb (category)
   * H-3 : questionStep
   *
   *
   * onClicks from rte-content :
   *
   * C-2 : contact
   */
  const appDOMNodesOnClicksFromRteContent = dom.querySelectorAll(
    ".autodata-onClick"
  );

  if (appDOMNodesOnClicksFromRteContent.length > 0) {
    import("./onClicks" /* webpackChunkName: "app-autodata-onClicks" */).then(
      ({ default: startApp }) => {
        if (!disposing) {
          startedApps.push(
            startApp(appDOMNodesOnClicksFromRteContent, autoData)
          );
        }
      }
    );
  }

  /**
   *
   * Autodata on clicks :
   *
   * onClicks from rte-content :
   *
   * C-2 : contact
   */
  const appDOMNodesContactLinks = dom.querySelectorAll(
    ".contact__element.rte-content a"
  );

  if (appDOMNodesContactLinks.length > 0) {
    import("./contacts" /* webpackChunkName: "app-autodata-contacts" */).then(
      ({ default: startApp }) => {
        if (!disposing) {
          startedApps.push(startApp(appDOMNodesContactLinks, autoData));
        }
      }
    );
  }

  /**
   *
   * Autodata onClicks events send in preact components :
   *
   * F-3 : Result
   * H-4 : UsefulQuestion
   * H-5 : SimilarQuestion
   *
   * **/

  /**
   *
   * Autodata search widget :
   *
   * B-3 : openQuestion
   * B-4 : MoreResult
   *
   * **/
  const appDOMNodesSearchWidget = dom.querySelectorAll(
    ".autodata-searchWidget"
  );

  if (appDOMNodesSearchWidget.length > 0) {
    if (!disposing) {
      import(
        "./searchWidget" /* webpackChunkName: "app-autodata-searchWidget" */
      ).then(({ default: startApp }) => {
        if (!disposing) {
          startedApps.push(startApp(autoData));
        }
      });
    }
  }

  /**
   *
   * Autodata pageviews
   *
   * **/
  const appDOMNodesPageViews = dom.querySelectorAll(".autodata-pageView");

  if (appDOMNodesPageViews.length > 0) {
    import("./pageviews" /* webpackChunkName: "app-autodata-pageViews" */).then(
      ({ default: startApp }) => {
        if (!disposing) {
          startApp(appDOMNodesPageViews, autoData);
        }
      }
    );
  }

  /**
   *
   * Autodata search results
   *
   * **/
  const appDOMNodeSearchResults = dom.querySelector(".searchResults");

  if (appDOMNodeSearchResults !== null) {
    import(
      "./searchResults" /* webpackChunkName: "app-autodata-pageViews" */
    ).then(({ default: startApp }) => {
      if (!disposing) {
        startApp(autoData);
      }
    });
  }

  return startedApps;
};

export default (): DisposableApp => {
  let autoDataInitialized = false;
  let disposing = false;
  let startedApps: DisposableApp[] = [];

  if (!disposing) {
    import("autodata" /* webpackChunkName: "autodata" */).then(
      ({ default: autoData }) => {
        if (!autoDataInitialized) {
          autoData.init({
            common: {
              tms: {
                debug: "debug",
                name: "gtm",
                enhancer: function enhancer(tag, type) {
                  switch (type) {
                    case "event":
                    case "pageview":
                      return {
                        ...window.dynamic_faq.common_page_view_data,
                        ...tag,
                      };
                    default:
                      return tag;
                  }
                },
              },
              plugins: {
                eventTracker: {
                  attributePrefix: "data-event-",
                  trigger: "cat",
                  attributes: ["action", "label", "value"],
                },
              },
            },
          });

          autoDataInitialized = true;
        }

        startedApps = startAutoDataApps(disposing, autoData);
      }
    );
  }

  return function disposableCallback() {
    disposing = true;

    startedApps.forEach((disposeApp: DisposableApp) => {
      if (disposeApp) {
        disposeApp();
      }
    });
  };
};
